import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, { licencePlate, pageSkip, pageLimit, onlyNegative }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
  };

  const query = `licencePlate=${licencePlate}&pageSkip=${pageSkip}&pageLimit=${pageLimit}&onlyNegative=${onlyNegative}`;

  const userLoginInfoResult = await fetch(
    `${URI_TARIFF_PLAN}reversion/wallet?${query}`,
    opts,
  );
  const jsonResult = await userLoginInfoResult.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
